import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import OfflineDataService, { OfflineConfigSettings } from "../../services/offline-data-service/OfflineDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

type MutationContextType = {
    previous: OfflineConfigSettings | undefined;
};

export function useSaveOfflineConfig(params: BaseUseQueryParameters<void>) {

    const queryClient = useQueryClient();

    return useMutation<void, RestError, OfflineConfigSettings, MutationContextType>((data) => {
        // must return promise!
        return  Promise.resolve(OfflineDataService.setOfflineMode(data.enabled ?? false));
     },{
            onMutate: async (config: OfflineConfigSettings) => {

                await queryClient.cancelQueries(keys.all);

                const previous = queryClient.getQueryData<OfflineConfigSettings>(
                    keys.configuration()
                );

                queryClient.setQueryData<OfflineConfigSettings>(
                    keys.configuration(),
                    (old?: OfflineConfigSettings) => {
                        return old ?? config;
                    }
                );

                return {
                    previous
                };
            },
            onError: params.onError,
            onSuccess: params.onSuccess,
            onSettled: (_data, error, _config, context) => {

                if (error && context?.previous) {
                    queryClient.setQueryData<OfflineConfigSettings>(
                        keys.configuration(),
                        context?.previous
                    );
                }

                queryClient.invalidateQueries(keys.configuration());
            }
        }
    );
}
